<div class="modal-header" ngbAutofocus>
  <h4 class="modal-title">{{ title }}</h4>
  <a type="button" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fs-5 bi bi-x-lg fw-bold"></i>
  </a>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light btn-lg" (click)="activeModal.close('Close click')"><i class="bi bi-x fw-bold me-2"></i> {{ cancelText }}</button>
  <button type="button" class="btn {{ actionBtnClass }} btn-lg"
  (click)="action();activeModal.close('Close click')"><i class="bi bi-arrow-right fw-bold me-2"></i> {{ actionText }}</button>
</div>
